import * as React from "react";
const SvgRightLeftArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 14 12"
    {...props}
  >
    <path
      fill="#091E42"
      d="M3.667 11.333.334 8l3.333-3.333.934.95-1.717 1.716h4.783v1.334H2.884l1.717 1.716zm6.667-4-.933-.95 1.716-1.716H6.334V3.333h4.783L9.401 1.617l.933-.95L13.667 4z"
    />
  </svg>
);
export default SvgRightLeftArrow;
